import { useDispatch, useSelector } from "react-redux";

import { useGetSettings } from "@/api/configuration/useConfigurationAPI";
import { LayerIcon, PlusIcon } from "@/assets/icons";
import EmptyPlaceholder from "@/components/emptyPlaceholder";
import { Button } from "@/components/ui/button";
import { useMap } from "@/hooks/map/core/useMapContext";
import { RootState } from "@/store";
import { enableDrawPolygon } from "@/store/slice/uiSlice";

import PolygonItem from "../polygonSettings/polygonItem";

const TEST_ID_PREFIX = "catchment-polygon-input";

export default function CatchmentPolygon() {
  const dispatch = useDispatch();

  const { enterDrawMode } = useMap();

  const { data } = useGetSettings();

  const { polygonSettingsTemp } = useSelector(
    (state: RootState) => state.spatial
  );

  const handleAddMorePolygon = () => {
    dispatch(enableDrawPolygon());
    enterDrawMode();
  };

  return (
    <div>
      <p className="text-[10px] mt-2">
        List of polygon{" "}
        <span className="text-teal-500" data-testid="polygon-count">
          {Object.keys(polygonSettingsTemp ?? {}).length || 0}/
          <b>{data?.max_catchments || 100}</b>
        </span>
      </p>

      <div className="flex flex-col mt-3 space-y-3">
        <div className="flex flex-col space-y-3 max-h-[258px] overflow-y-auto">
          {polygonSettingsTemp &&
          Object.keys(polygonSettingsTemp).length > 0 ? (
            Object.keys(polygonSettingsTemp).map((key) => (
              <PolygonItem key={key} polygon={polygonSettingsTemp[key]} />
            ))
          ) : (
            <EmptyPlaceholder
              className="my-3 bg-white px-4"
              icon={
                <LayerIcon
                  className="fill-light-gray mb-2.5"
                  width={21}
                  height={24}
                />
              }
              description="You do not have saved custom polygon"
            />
          )}
        </div>

        <Button
          variant="ghost"
          type="button"
          className="mx-auto w-full mt-0 disabled:bg-transparent group"
          onClick={handleAddMorePolygon}
          disabled={
            Object.keys(polygonSettingsTemp ?? {}).length ===
            (data?.max_catchments || 100)
          }
          data-testid={`${TEST_ID_PREFIX}-add-more-button`}
        >
          <PlusIcon
            width={12}
            className="fill-dim-gray group-disabled:fill-dim-gray/30"
          />
          <span className="text-sm font-semibold text-dim-gray group-disabled:text-dim-gray/30">
            Add More
          </span>
        </Button>
      </div>
    </div>
  );
}
